import { civilDaysPastDue, effectiveTituloStatus, parseCivilDateString } from '@/lib/utils';

export type GestorActionStatus = 'ACEITO' | 'NEGADO' | null;

export function getGestorActionStatus(card: {
  gestorActionStatus?: GestorActionStatus;
  feedbacks?: Array<{ tipo?: string; tipoNegociacao?: string; createdAt?: string }>;
}): GestorActionStatus {
  if (card.gestorActionStatus === 'ACEITO' || card.gestorActionStatus === 'NEGADO') {
    return card.gestorActionStatus;
  }

  if (!card.feedbacks || !Array.isArray(card.feedbacks)) {
    return null;
  }

  const gestorFeedbacks = card.feedbacks
    .filter((feedback) => feedback.tipo === 'GESTOR_RESPONSE')
    .sort((a, b) => new Date(b.createdAt ?? 0).getTime() - new Date(a.createdAt ?? 0).getTime());

  if (gestorFeedbacks.length === 0) {
    return null;
  }

  const ultimoFeedback = gestorFeedbacks[0];
  if (ultimoFeedback.tipoNegociacao === 'GESTOR_ACEITOU') {
    return 'ACEITO';
  }
  if (ultimoFeedback.tipoNegociacao === 'GESTOR_NEGOU') {
    return 'NEGADO';
  }

  return null;
}

export function calcularDiasAtraso(titulos: Array<{ status?: string; vencimento?: string | Date }>): number {
  const titulosVencidos = titulos.filter(
    (t) =>
      effectiveTituloStatus(t.status ?? '', t.vencimento ?? '') === 'VENCIDO' || t.status === 'PARCIAL'
  );
  if (titulosVencidos.length === 0) return 0;
  const tituloMaisAntigo = titulosVencidos.reduce((maisAntigo, atual) =>
    parseCivilDateString(atual.vencimento ?? '') < parseCivilDateString(maisAntigo.vencimento ?? '')
      ? atual
      : maisAntigo
  );
  if (!tituloMaisAntigo.vencimento) return 0;
  return civilDaysPastDue(tituloMaisAntigo.vencimento);
}

export function ordenarKanbanCards(
  cards: any[],
  sortBy: 'diasAtraso' | 'valorVencido',
  sortOrder: 'asc' | 'desc'
): any[] {
  return [...cards].sort((a, b) => {
    const titulosA = Array.isArray(a.titulos) ? a.titulos : [];
    const titulosB = Array.isArray(b.titulos) ? b.titulos : [];

    let valorA: number;
    let valorB: number;

    if (sortBy === 'diasAtraso') {
      valorA = calcularDiasAtraso(titulosA);
      valorB = calcularDiasAtraso(titulosB);
    } else {
      valorA = titulosA
        .filter((t: any) => effectiveTituloStatus(t.status, t.vencimento) === 'VENCIDO')
        .reduce((sum: number, t: any) => sum + Number(t.saldo || t.valor), 0);
      valorB = titulosB
        .filter((t: any) => effectiveTituloStatus(t.status, t.vencimento) === 'VENCIDO')
        .reduce((sum: number, t: any) => sum + Number(t.saldo || t.valor), 0);
    }

    return sortOrder === 'asc' ? valorA - valorB : valorB - valorA;
  });
}
